<script lang="ts" module>
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import { tv } from '../tv';

	export const overlayBackdropVariants = tv({
		base: 'absolute inset-s0 -z-1 animate-fade-in bg-other-overlay'
	});

	export interface OverlayBackdropProps extends Omit<HTMLAttributes<HTMLElement>, 'class'> {
		as?: string;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		as = 'div',
		class: className,
		ref = $bindable(null),
		...rest
	}: OverlayBackdropProps = $props();
</script>

<svelte:element this={as} bind:this={ref} class={[overlayBackdropVariants(), className]} {...rest}
></svelte:element>
